import { useEffect, useRef, useState } from "react";
import "../App.css";
import { toast } from "react-toastify";
import { AddCircleOutlineRounded } from "@mui/icons-material";
import "./Section.css";
import addImageIcon from "../assets/icons/add-image.png";
import { TextField } from "@mui/material";
import LanguagesDataTable from "../components/data-tables/LanguagesDataTable";
import { API } from "../assets/staticData";

let userToken = localStorage.getItem("userToken");

const headers = {
  Authorization: `Bearer ${userToken}`,
};

export default function Languages({ user }) {
  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [image, setImage] = useState(null);
  const formData = new FormData();
  const hiddenFileInput = useRef();

  const [data, setData] = useState({
    language: "",
  });

  useEffect(() => {
    async function getData() {
      fetch(`${API}/languages?populate=*`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setItems(respone.data);
      });
    }

    getData();
  }, [refresh]);

  if (error) {
    // Print errors if any
    return <div>An error occured: {error.message}</div>;
  }

  const handleBannerDataChange = (field, value) => {
    setData({
      ...data,
      [field]: value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage(file);
    }
  };

  const uploadBanner = () => {
    if (data.platformName !== "" && image !== null) {
      formData.append("data", JSON.stringify(data));
      formData.append("files.icon", image, image.name);
      fetch(`${API}/languages`, {
        headers,
        method: "POST",
        body: formData,
      })
        .then(() => {
          setData({ language: "" });
          setImage(null);
          setOpenAdd(false);
          setRefresh(!refresh);
          toast("The entry was successfully added", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        })
        .catch((error) => setError(error));
    } else {
      toast("Please fill in the required fields", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        type: "error",
      });
    }
  };

  return (
    <div className="App">
      <div>
        <h3 style={{ textAlign: "start", marginBottom: 10 }}>
          Language Settings
        </h3>
        {user.perms[0].add && (
          <div
            className="addC"
            style={{
              minHeight: openAdd ? 400 : 50,
              padding: openAdd ? 20 : 0,
            }}
          >
            {openAdd && (
              <div
                className="addContent"
                style={{
                  marginTop: 10,
                  marginBottom: 20,
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "50%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <TextField
                    label="Language"
                    sx={{ width: "90%" }}
                    size="small"
                    value={data.language}
                    onChange={(e) =>
                      handleBannerDataChange("language", e.target.value)
                    }
                  />
                  <div
                    style={{
                      border: "dashed",
                      borderWidth: 1,
                      borderColor: "grey",
                      height: 135,
                      marginTop: 1,
                      width: "90%",
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                      justifyContent: "center",
                      borderRadius: 5,
                      cursor: "pointer",
                    }}
                    onClick={() => hiddenFileInput.current.click()}
                  >
                    {image ? (
                      <img
                        src={URL.createObjectURL(image)}
                        style={{
                          width: 55,
                          aspectRatio: 1,
                          borderRadius: 55,
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <img src={addImageIcon} style={{ width: 55 }} />
                    )}
                    <p style={{ color: "#888", fontSize: 13 }}>
                      Click here to add an icon
                    </p>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      ref={hiddenFileInput}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </div>
            )}
            <div
              className="addBTN"
              onClick={() => (openAdd ? uploadBanner() : setOpenAdd(true))}
              style={{ width: openAdd ? "50%" : "100%" }}
            >
              Add a new Language
              <AddCircleOutlineRounded style={{ marginLeft: 7 }} />
            </div>

            {openAdd && (
              <div
                onClick={() => {
                  setOpenAdd(false);
                  setImage(null);
                }}
                className="cancelBTN"
              >
                Cancel
              </div>
            )}
          </div>
        )}

        <LanguagesDataTable data={items} user={user} />
      </div>
    </div>
  );
}
